<template>
  <div class="bubble-text-msg">
    <div class="bubble-text"
         data-qa="bubble-text"
         :class="{'collapsed-text': shouldCollapseMessage}"
         ref="bubbleText"
         v-html="textToDisplay"/>

    <div class="show-more"
         data-qa="show-more-btn"
         v-if="shouldDisplayShowMoreBtn"
         @click="isShowMore = !isShowMore">
      {{ isShowMore ? $t('client.matters.conversation.show_more') : $t('client.matters.conversation.show_less') }}
    </div>
  </div>
</template>
<script>
import LinkyTrust from '@/modules/common/filters/LinkyTrust'
export default {
  name: 'BubbleTextMsg',
  props: {
    text: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isMounted: false,
      isShowMore: true,
    }
  },
  mounted() {
    this.isMounted = true;
  },
  computed: {
    shouldCollapseMessage() {
      return this.hasCollapseLongMessageFF && this.isShowMore;
    },
    shouldDisplayShowMoreBtn() {
      return this.hasCollapseLongMessageFF && this.isLongMessage;
    },
    hasCollapseLongMessageFF() {
      return this.$hasFeature('collapse_long_message_backoffice')
    },
    textToDisplay() {
      return LinkyTrust(this.text, '_blank');
    },
    isLongMessage() {
      if(this.isMounted) {
        const element = this.$refs && this.$refs.bubbleText;
        return element.scrollHeight > element.offsetHeight;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/abstract/_variables';

.bubble-text-msg {

  .collapsed-text {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .show-more {
    margin-top: 4px;
    color: $blue-color-4;
    white-space: normal;
    cursor: pointer;
  }
}
</style>
